import { weekIndexMap as l } from "./index.es668.js";

var s = function s(r) {
  var n = Array(6).fill(null).map(function () {
    return Array(7).fill(null);
  }),
      a = l[new Date(new Date(r).setDate(1)).getDay()];

  for (var e = 0; e < n.length; e += 1) {
    for (var t = 0; t < n[e].length; t += 1) {
      n[e][t] = new Date(new Date(new Date(r).setHours(0, 0, 0, 0)).setDate(7 * e + t - a + 1));
    }
  }

  return n.filter(function (e) {
    return !e.every(function (t) {
      return t.getMonth() !== r.getMonth();
    });
  }).map(function (e, t) {
    return {
      key: t,
      week: e
    };
  });
};

export { s as getMonthList };